/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ price: NonNullable<unknown>, number: NonNullable<unknown> }} Purchase_Confirm_In_App_PurchaseInputs */

const en_purchase_confirm_in_app_purchase = /** @type {(inputs: Purchase_Confirm_In_App_PurchaseInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Use ${i?.price} to buy ${i?.number} Time Crystals?`)
};

const ar_purchase_confirm_in_app_purchase = /** @type {(inputs: Purchase_Confirm_In_App_PurchaseInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`هل تريد استخدام ${i?.price} لشراء ${i?.number} من بلورات الزمن؟`)
};

const de_purchase_confirm_in_app_purchase = /** @type {(inputs: Purchase_Confirm_In_App_PurchaseInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.price} verwenden, um ${i?.number} Time Crystals zu kaufen?`)
};

const es_purchase_confirm_in_app_purchase = /** @type {(inputs: Purchase_Confirm_In_App_PurchaseInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`¿Usar ${i?.price} para comprar ${i?.number} Cristales de tiempo?`)
};

const fr_purchase_confirm_in_app_purchase = /** @type {(inputs: Purchase_Confirm_In_App_PurchaseInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Utiliser ${i?.price} pour acheter ${i?.number} Cristaux temporels ?`)
};

const it_purchase_confirm_in_app_purchase = /** @type {(inputs: Purchase_Confirm_In_App_PurchaseInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Usare ${i?.price} per acquistare ${i?.number} Cristalli del Tempo?`)
};

const ja_purchase_confirm_in_app_purchase = /** @type {(inputs: Purchase_Confirm_In_App_PurchaseInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.price}を支払って${i?.number}個の時の結晶を購入しますか？`)
};

const ko_purchase_confirm_in_app_purchase = /** @type {(inputs: Purchase_Confirm_In_App_PurchaseInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.price}(으)로 ${i?.number} 타임 크리스탈을 구매할까요?`)
};

const pt_br_purchase_confirm_in_app_purchase = /** @type {(inputs: Purchase_Confirm_In_App_PurchaseInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Usar ${i?.price} para comprar ${i?.number} Cristais do Tempo?`)
};

const ru_purchase_confirm_in_app_purchase = /** @type {(inputs: Purchase_Confirm_In_App_PurchaseInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Потратить ${i?.price}, чтобы купить ${i?.number} кристаллов времени?`)
};

const th_purchase_confirm_in_app_purchase = /** @type {(inputs: Purchase_Confirm_In_App_PurchaseInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`ใช้ ${i?.price} เพื่อซื้อ ${i?.number} คริสตัลแห่งกาลเวลาไหม?`)
};

const tr_purchase_confirm_in_app_purchase = /** @type {(inputs: Purchase_Confirm_In_App_PurchaseInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.number} Zaman Kristali satın almak için ${i?.price} kullanılsın mı?`)
};

const zh_cn_purchase_confirm_in_app_purchase = /** @type {(inputs: Purchase_Confirm_In_App_PurchaseInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`用 ${i?.price} 购买 ${i?.number} 时光宝石？`)
};

const zh_tw_purchase_confirm_in_app_purchase = /** @type {(inputs: Purchase_Confirm_In_App_PurchaseInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`用 ${i?.price} 購買 ${i?.number} 時光寶石？`)
};

/**
* | output |
* | --- |
* | "Use {price} to buy {number} Time Crystals?" |
*
* @param {Purchase_Confirm_In_App_PurchaseInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const purchase_confirm_in_app_purchase = /** @type {((inputs: Purchase_Confirm_In_App_PurchaseInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Purchase_Confirm_In_App_PurchaseInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_purchase_confirm_in_app_purchase(inputs)
	if (locale === "ar") return ar_purchase_confirm_in_app_purchase(inputs)
	if (locale === "de") return de_purchase_confirm_in_app_purchase(inputs)
	if (locale === "es") return es_purchase_confirm_in_app_purchase(inputs)
	if (locale === "fr") return fr_purchase_confirm_in_app_purchase(inputs)
	if (locale === "it") return it_purchase_confirm_in_app_purchase(inputs)
	if (locale === "ja") return ja_purchase_confirm_in_app_purchase(inputs)
	if (locale === "ko") return ko_purchase_confirm_in_app_purchase(inputs)
	if (locale === "pt_br") return pt_br_purchase_confirm_in_app_purchase(inputs)
	if (locale === "ru") return ru_purchase_confirm_in_app_purchase(inputs)
	if (locale === "th") return th_purchase_confirm_in_app_purchase(inputs)
	if (locale === "tr") return tr_purchase_confirm_in_app_purchase(inputs)
	if (locale === "zh_cn") return zh_cn_purchase_confirm_in_app_purchase(inputs)
	return zh_tw_purchase_confirm_in_app_purchase(inputs)
});